export const translator = (i18n: any, key: string): string => {
    const locale = i18n.locale;
    return i18n.translations[locale][key];
};
